// Renders a list of categories as HierarchicalRefinementListElement with
// accessible subcategories as Flyouts. Controls the Flyout state for all Flyouts
// rendered by this component as well as callbacks for controlling them on
// desktop/mobile

import React, { useEffect, useState } from "react";
import { connectRefinementList } from "react-instantsearch-dom";
import PropTypes from "prop-types";

import { XS_PIXEL_MAX } from "constants/breakpoints";
import HierarchicalRefinementListElement from "components/search/base/HierarchicalRefinementListElement";

const propTypes = {
  attribute: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  items: PropTypes.array,
  refine: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

const defaultProps = {
  items: []
};

const HierarchicalRefinementList = (props) => {
  // Only one flyout can be visible at a time, this manages the state
  const [flyState, setFlyState] = useState(null);

  // Stores the internal state for all of the flyouts by category
  const [refinedValues, updateRefinedValue] = useState({});

  // Pass the internally stored refined values to Algolia
  useEffect(() => {
    props.refine([].concat(...Object.values(refinedValues)));
  }, [refinedValues]);

  const handleRefine = (values, category) => {
    updateRefinedValue((prevState) => ({ ...prevState, [category]: values }));
  };

  // Add events to manage showing/hiding flyouts
  useEffect(() => {
    if (flyState === null) {
      document.removeEventListener("click", outsideFlyoutClickListener);
      document.removeEventListener("touchend", outsideFlyoutClickListener);
    } else {
      document.addEventListener("click", outsideFlyoutClickListener);
      document.addEventListener("touchend", outsideFlyoutClickListener);
    }

    return function cleanup() {
      document.removeEventListener("click", outsideFlyoutClickListener);
      document.removeEventListener("touchend", outsideFlyoutClickListener);
    };
  }, [flyState]);

  const toggleFlyout = (category) => {
    if (category === null) {
      $(".search__filters").removeClass("search__filters--with-flyout");
    } else {
      $(".search__filters").addClass("search__filters--with-flyout");
    }

    setFlyState(category);
  };

  // Closes flyout if clicked outside of it
  const outsideFlyoutClickListener = (event) => {
    const $target = $(event.target);
    if (
      !$target.closest($(".refinement-list__flyout")).length &&
      $(".refinement-list__flyout").is(":visible")
    ) {
      toggleFlyout(null);
    }
  };

  // Closes flyout if hovered outside of it
  const outsideFlyoutHover = (event) => {
    // Hovers only registered on large size
    if (window.innerWidth <= XS_PIXEL_MAX) {
      return;
    }

    const $target = $(event.target);
    if (
      !$target.closest($(".refinement-list__flyout")).length &&
      $(".refinement-list__flyout").is(":visible")
    ) {
      toggleFlyout(null);
    }
  };

  return (
    <div className="refinement-list" onMouseLeave={outsideFlyoutHover}>
      <div className="refinement-list__header">{props.title}</div>
      <ul className="refinement-list__list refinement-list__list--hierarchical">
        {props.categories.map((category) => {
          const items =
            props.items.filter(
              (i) => i.label.split(" > ")[0] === category.value
            ) || [];
          const showFlyout = flyState === category.value;

          return (
            <HierarchicalRefinementListElement
              attribute={props.attribute}
              currentRefinement={props.currentRefinement}
              handleClick={toggleFlyout}
              handleRefine={handleRefine}
              items={items}
              key={category.value}
              label={category.label}
              showFlyout={showFlyout}
              value={category.value}
            />
          );
        })}
      </ul>
    </div>
  );
};

HierarchicalRefinementList.propTypes = propTypes;
HierarchicalRefinementList.defaultProps = defaultProps;

export default connectRefinementList(HierarchicalRefinementList);
